import mixpanel from 'mixpanel-browser';

import { isPresent } from 'shared/lib/utils';
import { trackError } from '@/lib/error_tracker';

mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN);

export function trackEvent(session, pathname, eventName, event) {
  try {
    let sessionObject;
    let sessionIdAndUserId;

    if (session && session.toJS) {
      sessionObject = session.toJS();
      sessionIdAndUserId = {
        sessionId: session.getIn(['session', 'id']),
        userId: session.getIn(['user', 'id']),
      };
    }

    mixpanel.track(eventName, {
      ...sessionIdAndUserId,
      ...event,
      pathname,
    });

    if (process.env.NEXT_PUBLIC_EVENT_TRACKER_CONSOLE_LOG === 'true') {
      console.log(['event', eventName, { ...event, pathname }, sessionObject]);
    }
  } catch (e) {
    trackError(session, 'Event Tracking Failed', e, eventName);
  }
}

export function trackInteraction(session, pathname, eventName, event) {
  return trackEvent(session, pathname, eventName, {
    interaction: true,
    ...event,
  });
}

export function trackClick(session, pathname, target, metadata) {
  return trackInteraction(session, pathname, `${target} Clicked`, metadata);
}

export function acknowledgeAuthentication(session, _pathname, _metadata) {
  const userId = session.getIn(['user', 'id']);

  if (!isPresent(userId)) {
    if (process.env.NEXT_PUBLIC_EVENT_TRACKER_CONSOLE_LOG === 'true') {
      console.warn(['mixpanel.identify', 'No user ID found']);
    }

    return;
  }

  const distinctId = mixpanel.persistence?.props?.distinct_id;

  if (isPresent(distinctId) && distinctId === userId) {
    if (process.env.NEXT_PUBLIC_EVENT_TRACKER_CONSOLE_LOG === 'true') {
      console.info(['mixpanel.identify', 'distinct ID already set']);
    }

    return;
  }

  // https://help.mixpanel.com/docs/tracking/how-tos/identifying-users
  mixpanel.identify(userId);

  if (process.env.NEXT_PUBLIC_EVENT_TRACKER_CONSOLE_LOG === 'true') {
    console.log(['mixpanel.identify', userId]);
  }
}

export function acknowledgeSignout(_session, _pathname, _metadata) {
  mixpanel.reset();

  if (process.env.NEXT_PUBLIC_EVENT_TRACKER_CONSOLE_LOG === 'true') {
    console.log(['mixpanel.reset']);
  }
}
